import { Component } from '@angular/core';
import { Buyer, BuyersService } from 'src/app/core/buyers.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { ERROR_BUYER_NOT_FOUND } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-home-buyers',
  templateUrl: './home-buyers.component.html',
  styleUrls: ['./home-buyers.component.scss'],
})
export class HomeBuyersComponent {
  is_list_running: boolean = false;
  buyers?: Buyer[];

  constructor(
    private buyers_service: BuyersService,
    private error_service: ErrorService,
    private navigation_service: NavigationService,
  ) {}

  ngOnInit(): void {
    this.listBuyers();
  }

  onRefresh(): void {
    this.listBuyers();
  }

  onSeeAllClick(): void {
    this.navigation_service.toBuyers();
  }

  listBuyers(): void {
    this.is_list_running = true;
    this.buyers_service.listBuyers({ cursor: null, limit: 5 }).subscribe({
      next: response => {
        this.buyers = response.data.data;
        this.is_list_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        if (processed_error.code == ERROR_BUYER_NOT_FOUND) {
          this.buyers = [];
        } else {
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
        this.is_list_running = false;
      },
    });
  }
}
